import { render, staticRenderFns } from "./ArchivedInvoicesUpload.vue?vue&type=template&id=1bec548e"
import script from "./ArchivedInvoicesUpload.vue?vue&type=script&lang=js"
export * from "./ArchivedInvoicesUpload.vue?vue&type=script&lang=js"
import style0 from "./ArchivedInvoicesUpload.vue?vue&type=style&index=0&id=1bec548e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports